<div class="align-content-end">
    <nav>
        <ul class="pagination default" [class.hidden]="totalPages < 2">
            <li class="page-item" [class.active]="i === currentPage" *ngFor="let item of getCounters(); let i=index" (click)="i !== currentPage && goToPage(i)"><a class="page-link">{{i + 1}}</a></li>
<!--            <li class="page-item"><a class="page-link">2</a></li>-->
<!--            <li class="page-item"><a class="page-link">3</a></li>-->
        </ul>
    </nav>
</div>
